export function HasFieldCondition(fieldName) {
  // return ({ content }) => content && Object.hasOwn(content, fieldName);
  return ({ content }) => content && content.hasOwnProperty(fieldName);
}

export function NotContentTypeCondition(contentTypes) {
  return ({ content }) =>
    content?.['@type'] && !contentTypes.includes(content?.['@type']);
}

export function ContentTypeCondition(contentTypes) {
  return ({ content }) => contentTypes.includes(content?.['@type']);
}

export function NotEndingWithCondition(suffix) {
  return ({ location }) => !location.pathname.endsWith(suffix);
}

export function HasTitleBlockCondition() {
  return ({ content }) => {
    if (!content || !content.blocks) {
      return false;
    }

    const blockList = Array.isArray(content.blocks)
      ? content.blocks
      : Object.values(content.blocks);

    const hasTitleBlock = blockList.some((block) => {
      const type = block?.['@type'] || block?.type;
      return typeof type === 'string' && type.toLowerCase() === 'title';
    });

    return !hasTitleBlock;
  };
}
